import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
import { CheckboxInput } from '../CheckboxInput/CheckboxInput';
import { useCustomInput } from '../utils/useCustomInput';
export type FieldTypeCheckbox = {
  choices?: Array<{
    label: string;
    value: string;
    disable?: boolean;
  }>;
  required?: boolean;
  type: 'wrappedcheckboxselectmultiple' | 'textinput' | undefined;
};
export function CheckboxGroupInput(props) {
  const $ = _c(30);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props.fields) {
    t0 = props.fields.some(_temp);
    $[0] = props.fields;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasTextInput = t0;
  let t1;
  if ($[2] !== props.fields[0].choices || $[3] !== props.input.onChange || $[4] !== props.input.value) {
    t1 = {
      initInputValue: props.input.value,
      inputOnChange: props.input.onChange,
      choices: props.fields[0].choices
    };
    $[2] = props.fields[0].choices;
    $[3] = props.input.onChange;
    $[4] = props.input.value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    handleCustomInputChange
  } = useCustomInput(t1);
  let t2;
  if ($[6] !== props.input) {
    t2 = function handleSelect(value) {
      const currentValue = props.input.value ? Array.isArray(props.input.value) ? props.input.value : [props.input.value] : [];
      if (currentValue.includes(value)) {
        const newValue = [...new Set(currentValue.filter(v => v !== value))];
        if (newValue.length === 0) {
          props.input.onChange(undefined);
        } else {
          props.input.onChange(newValue);
        }
      } else {
        const newValue_0 = [...new Set([...currentValue, value])];
        props.input.onChange(newValue_0);
      }
    };
    $[6] = props.input;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleSelect = t2;
  const t3 = hasError ? errorId : undefined;
  const t4 = hasError ? "true" : "false";
  let t5;
  if ($[8] !== handleCustomInputChange || $[9] !== handleSelect || $[10] !== hasTextInput || $[11] !== props.fields || $[12] !== props.input.name || $[13] !== props.input.value) {
    let t6;
    if ($[15] !== handleCustomInputChange || $[16] !== handleSelect || $[17] !== hasTextInput || $[18] !== props.input.name || $[19] !== props.input.value) {
      t6 = (field_0, index) => {
        if (field_0.type === "wrappedcheckboxselectmultiple") {
          return <Fragment key={index}>{field_0.choices?.map((choice, index_0) => {
              const isLast = index_0 === (field_0.choices?.length || 0) - 1;
              return <label className="block" key={index_0}><span><CheckboxInput label={choice.label} input={{
                    name: `${choice.label}-${props.input.name}`,
                    onChange: event => {
                      handleSelect(event.target.value);
                    },
                    checked: props.input.value?.includes(choice.value),
                    value: choice.value,
                    disabled: choice.disable
                  }} meta={{}} />{isLast && hasTextInput && <input className="input mt-4" type="text" onChange={e => handleCustomInputChange(e.target.value)} />}</span></label>;
            })}</Fragment>;
        }
      };
      $[15] = handleCustomInputChange;
      $[16] = handleSelect;
      $[17] = hasTextInput;
      $[18] = props.input.name;
      $[19] = props.input.value;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t5 = props.fields.map(t6);
    $[8] = handleCustomInputChange;
    $[9] = handleSelect;
    $[10] = hasTextInput;
    $[11] = props.fields;
    $[12] = props.input.name;
    $[13] = props.input.value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[21] !== errorId || $[22] !== hasError || $[23] !== props.meta.error) {
    t6 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[21] = errorId;
    $[22] = hasError;
    $[23] = props.meta.error;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t7 = <div className="relative flex flex-col gap-4" aria-describedby={t3} aria-invalid={t4}>{t5}{t6}</div>;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}
function _temp(field) {
  return field.type === "textinput";
}